import * as React from 'react'

export const WidelyAvailable = props => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 540 300">
        <path
            fill="#C4EED0"
            d="m420 30-30 30 90 90-90 90-60-60-30 30 90 90 150-150zM150 0 30 120l30 30 90-90 60 60 30-30z"
        ></path>
        <path fill="#1EA446" d="m390 0 30 30-270 270L0 150l30-30 120 120z"></path>
    </svg>
)
